module.exports = __webpack_public_path__ + "img/1.a33e3f47.jpg";